export class VerificationIsUserExistsInUserSitesEntity {
    phoneNumber;
    siteIds;

    constructor(phoneNumber = '', siteIds = []) {
        this.phoneNumber = phoneNumber;
        this.siteIds = siteIds;
    };
};